import React, {
  FunctionComponent,
  LiHTMLAttributes,
  SyntheticEvent,
} from 'react';

import BaseDropdownItem from '../BaseDropdownItem';
import styleClassNames from './styles.module.scss';

export interface ActionDropdownItemProps {
  name: Name;
  icon?: string;
  iconSize?: number;
  isDisplayed?: boolean;
  isTabbable?: boolean;
  isWarningItem?: boolean;
  onChoose?: (name: Name, e?: SyntheticEvent) => void;
}

type Name = string | number;

const ActionDropdownItem: FunctionComponent<ActionDropdownItemProps & LiHTMLAttributes<HTMLLIElement>> = (
  props
) => {
  const baseProps = {
    ...props,
    styleClassNames,
    variantName: 'action',
  };

  return <BaseDropdownItem {...baseProps} />;
};

export default ActionDropdownItem;
